import { Button } from "@mui/material";
import { Vocabulary } from "../../Utils/Vocabulary";
import GenericModal from "./GenericModal";

type DeleteWorkflowModalProps = {
  title: string;
  text: string;
  open: boolean;
  onClose: () => void;
  onSave: () => void;
};
export default function GenericConfirmModal(props: DeleteWorkflowModalProps) {
  const { open, title, text, onClose, onSave } = props;
  return (
    <GenericModal
      title={title}
      open={open}
      onClose={onClose}
      actions={
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            padding: 20,
          }}
        >
          <Button
            variant="contained"
            color="secondary"
            style={{ color: "white", backgroundColor: "#b35252" }}
            onClick={onClose}
          >
            {Vocabulary.no}
          </Button>
          <Button
            type="submit"
            style={{ color: "white", backgroundColor: "#18cc9c" }}
            variant="contained"
            onClick={onSave}
          >
            {Vocabulary.yes}
          </Button>
        </div>
      }
      children={
        <div>
          <p
            style={{
              fontSize: 19,
              fontWeight: 400,
              lineHeight: 1.5,
              letterSpacing: 0.5,
            }}
          >
            {text}
          </p>
        </div>
      }
      style={{ textAlign: "center" }}
      styleTitle={{
        padding: "10px",
        backgroundColor: "#18cc9c",
        color: "white",
        fontSize: 20,
      }}
    ></GenericModal>
  );
}
